export const queryKeys = {
  wishlist: {
    ids: ["wishlist", "ids"] as const,
    items: ["wishlist", "items"] as const,
  },
  orders: ["orders"] as const,
  profile: ["profile"] as const,
  categories: {
    list: ["categories"] as const,
    tree: ["categories", "tree"] as const,
  },
  brands: {
    list: ["brands"] as const,
  },
  banners: ["banners"] as const,
  hotOffersTimer: ["hot-offers-timer"] as const,
  products: {
    list: (queryString: string) => ["products", queryString] as const,
  },
} as const
